import { create } from 'zustand';

interface AddTechnicianModalState {
  isOpen: boolean;
  objectSlug?: string;
  open: (slug: string) => void;
  close: () => void;
}

export const useAddTechnicianModalStore = create<AddTechnicianModalState>(set => ({
  isOpen: false,
  objectSlug: undefined,
  open: (objectSlug: string) => set({ isOpen: true, objectSlug }),
  close: () => set({ isOpen: false, objectSlug: undefined }),
}));
